import { GetAllRawMaterialsResponse } from "./../Models/ServerModels/RawMaterials/GetAllRawMaterialsResponse";
import { ApiResponse } from "../Models";

export const GetAllRawMaterialsMockup: ApiResponse<GetAllRawMaterialsResponse> = {
  statusCode: 200,
  error: null,
  data: {
    unCoatedByHaifa: [],
    coated: [
      {
        name: "Multicote 2M 12-00-44",
        id: 1,
      },
      {
        name: "Multicote 4M 12-00-44",
        id: 2,
      },
      {
        name: "Multicote 8M 12-00-44",
        id: 3,
      },
      {
        name: "Multicote 12M 12-00-42",
        id: 4,
      },
      {
        name: "Multicote 2M 11-49-01",
        id: 5,
      },
      {
        name: "Multicote 4M 10-48-01",
        id: 6,
      },
      {
        name: "Multicote 8M 10-48-00",
        id: 7,
      },
      {
        name: "Cote N 2M 43-00-00",
        id: 8,
      },
      {
        name: "Cote N 3M 42-00-00",
        id: 9,
      },
      {
        name: "Cote N 4M 42-00-01",
        id: 10,
      },
      {
        name: "Cote N 6M 41-00-00",
        id: 11,
      },
      {
        name: "Cote N 8M 41-00-00",
        id: 12,
      },
      {
        name: "Cote N 12M 40-00-00",
        id: 13,
      },
      {
        name: "Multicote 2M 11-49-00",
        id: 14,
      },
      {
        name: "Multicote 4M 10-48-00",
        id: 15,
      },
      {
        name: "Multicote 8M 10-48-00",
        id: 16,
      },
      {
        name: "Multicote 2M 12-00-44",
        id: 17,
      },
      {
        name: "Multicote 4M 12-00-44",
        id: 18,
      },
      {
        name: "Multicote 8M 12-00-44",
        id: 19,
      },
      {
        name: "Multicote 12M 12-00-42",
        id: 20,
      },
    ],
    unCoated: [
      {
        name: "Ammonium Nitrate",
        id: 1,
      },
      {
        name: "Ammonium Sulphate",
        id: 2,
      },
      {
        name: "DAP",
        id: 3,
      },
      {
        name: "KCL",
        id: 4,
      },
      {
        name: "MAP",
        id: 5,
      },
      {
        name: "SOP",
        id: 6,
      },
      {
        name: "Triple Super Phosphate",
        id: 7,
      },
      {
        name: "Turbo-K 14-14-17+2MgO+ME",
        id: 8,
      },
      {
        name: "Turbo-K 15-15-15+2MgO+ME",
        id: 9,
      },
      {
        name: "Urea",
        id: 10,
      },
      {
        name: "10-10-10",
        id: 11,
      },
      {
        name: "11-10-10",
        id: 12,
      },
      {
        name: "10-10-10",
        id: 11,
      },
      {
        name: "11-10-10",
        id: 12,
      },
    ],
  },
};
